export const checkIfStoreIsOpen = (
    openingTime: string,
    closingTime: string
): boolean => {
    if (!openingTime || !closingTime) {
        return false;
    }

    const [openingHours, openingMinutes] = openingTime.split(':').map(Number);
    const [closingHours, closingMinutes] = closingTime.split(':').map(Number);

    const openingTotalMinutes = openingHours * 60 + openingMinutes;
    const closingTotalMinutes = closingHours * 60 + closingMinutes;

    const currentDate = new Date();
    const currentTotalMinutes =
        currentDate.getHours() * 60 + currentDate.getMinutes();

    // Normal same-day schedule: 09:00 - 18:00
    if (openingTotalMinutes < closingTotalMinutes) {
        return (
            currentTotalMinutes >= openingTotalMinutes &&
            currentTotalMinutes < closingTotalMinutes
        );
    }

    // Overnight schedule: 18:00 - 02:00
    if (openingTotalMinutes > closingTotalMinutes) {
        return (
            currentTotalMinutes >= openingTotalMinutes ||
            currentTotalMinutes < closingTotalMinutes
        );
    }

    // Opening and closing times are the same
    return false;
};